import { FC, ReactNode } from "react";

interface BlankLayoutProps {
  children?: ReactNode;
}

const BlankLayout: FC<BlankLayoutProps> = ({ children }) => (
  <div className="min-h-screen w-full relative">
    {children}
  </div>
);

export default BlankLayout;
